import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable indent */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import TermsAndConditons from '../TermsAndConditions';
import RichText from '../RichText';
import { TAGButton, TAGTypography, Container, Grid, Box, useMediaQuery } from '../../../';
import FocalPointImage from '../FocalPointImage';

var Hero = function Hero(_ref) {
  var _backgroundImage$file, _backgroundImage$file2, _backgroundImage$file3, _backgroundImage$file4, _backgroundImage$file5;

  var _ref$allTextColor = _ref.allTextColor,
      allTextColor = _ref$allTextColor === void 0 ? 'text.light' : _ref$allTextColor,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? true : _ref$background,
      _ref$backgroundImage = _ref.backgroundImage,
      backgroundImage = _ref$backgroundImage === void 0 ? {
    file: {
      url: ''
    }
  } : _ref$backgroundImage,
      _ref$backgroundText = _ref.backgroundText,
      backgroundText = _ref$backgroundText === void 0 ? false : _ref$backgroundText,
      body = _ref.body,
      _ref$bodySize = _ref.bodySize,
      bodySize = _ref$bodySize === void 0 ? 'Default' : _ref$bodySize,
      branding = _ref.branding,
      _ref$ctaStyle = _ref.ctaStyle,
      ctaStyle = _ref$ctaStyle === void 0 ? 'Primary Accent01' : _ref$ctaStyle,
      _ref$ctaText = _ref.ctaText,
      ctaText = _ref$ctaText === void 0 ? 'SCHEDULE APPOINTMENT' : _ref$ctaText,
      _ref$secondaryCtaStyl = _ref.secondaryCtaStyle,
      secondaryCtaStyle = _ref$secondaryCtaStyl === void 0 ? 'Secondary High Contrast' : _ref$secondaryCtaStyl,
      _ref$secondaryCtaText = _ref.secondaryCtaText,
      secondaryCtaText = _ref$secondaryCtaText === void 0 ? '' : _ref$secondaryCtaText,
      secondaryCtaUrl = _ref.secondaryCtaUrl,
      ctaUrl = _ref.ctaUrl,
      focalPointImage = _ref.focalPointImage,
      eyebrow = _ref.eyebrow,
      heading = _ref.heading,
      secondaryBackground = _ref.secondaryBackground,
      secondImage = _ref.secondImage,
      secondImageURL = _ref.secondImageURL,
      sx = _ref.sx,
      secondaryMessage = _ref.secondaryMessage,
      tc = _ref.tc,
      tertiaryImage = _ref.tertiaryImage;
  var theme = useTheme();
  var isSmallDevice = useMediaQuery(theme.breakpoints.down('md'));
  var isMediumDevice = useMediaQuery(theme.breakpoints.up('md'));
  var brandName = theme.palette.brandName;

  var backgroundTextStyles = function backgroundTextStyles() {
    if (!backgroundText) {
      return {
        clipPath: '',
        backgroundColor: 'transparent'
      };
    }

    switch (brandName) {
      case 'aspenDental':
        return {
          clipPath: 'polygon(0 0, 66% 0, 92% 100%, 0% 100%)',
          backgroundColor: '#002855E6'
        };

      case 'wellnow':
        return {
          clipPath: 'inset(0 0 0 0 round 0 25rem 0rem 0rem)',
          backgroundColor: '#003592'
        };

      default:
        return {
          clipPath: 'polygon(0 0, 66% 0, 92% 100%, 0% 100%)',
          backgroundColor: '#002855E6'
        };
    }
  };

  var ANGLE_BACKGROUND = _objectSpread({
    padding: eyebrow === '' ? '0px 0px 0px 60px' : '0px 0px 50px 60px',
    width: brandName === 'wellnow' ? '58%' : '80%',
    minHeight: '524px',
    borderRadius: secondaryMessage ? '8px 0px 0px 0px' : '8px 0px 0px 8px'
  }, backgroundTextStyles());

  var MOBILE_BACKGROUND = {
    backgroundColor: background ? 'backgrounds.dark' : 'none'
  };
  var HEADLINE_SIZE_MED = {
    fontSize: '53px',
    lineHeight: '78px'
  };
  var HEADLINE_SIZE_MOBILE = {
    fontSize: '41px',
    lineHeight: '52px',
    textAlign: 'center'
  };
  var HEADLINE_MED_DEVICE = {
    fontSize: '56px',
    lineHeight: '72px'
  };
  var BODY_COPY_LARGE = {
    fontSize: '22px',
    lineHeight: '32px'
  };
  var BODY_COPY_MED_DEVICE = {
    fontSize: '20px',
    lineHeight: '28px'
  };
  var BODY_COPY_SIZE_MOBILE = {
    fontSize: '20px',
    lineHeight: '28px',
    textAlign: 'center'
  };

  var headlineFontSwitch = function headlineFontSwitch(bodySize, isSmallDevice, isMediumDevice, brandName) {
    switch (true) {
      case brandName === 'wellnow':
        return null;

      case bodySize === 'Medium':
        return HEADLINE_SIZE_MED;

      case isMediumDevice:
        return HEADLINE_MED_DEVICE;

      case isSmallDevice == true:
        return HEADLINE_SIZE_MOBILE;
    }
  };

  var bodyCopyFontSwitch = function bodyCopyFontSwitch(bodySize, isSmallDevice, isMediumDevice, brandName) {
    switch (true) {
      case brandName === 'wellnow':
        return isSmallDevice ? {
          textAlign: 'center'
        } : null;

      case bodySize === 'Large':
        return BODY_COPY_LARGE;

      case isMediumDevice:
        return BODY_COPY_MED_DEVICE;

      case isSmallDevice == true:
        return BODY_COPY_SIZE_MOBILE;
    }
  };

  var smallScreenImageStyles = isSmallDevice ? {} : {
    backgroundColor: backgroundImage !== null && backgroundImage !== void 0 && (_backgroundImage$file = backgroundImage.file) !== null && _backgroundImage$file !== void 0 && _backgroundImage$file.url || focalPointImage ? '' : 'neutrals.disabled',
    backgroundImage: backgroundImage !== null && backgroundImage !== void 0 && (_backgroundImage$file2 = backgroundImage.file) !== null && _backgroundImage$file2 !== void 0 && _backgroundImage$file2.url && !focalPointImage ? "url(".concat(backgroundImage === null || backgroundImage === void 0 ? void 0 : (_backgroundImage$file3 = backgroundImage.file) === null || _backgroundImage$file3 === void 0 ? void 0 : _backgroundImage$file3.url, ")") : '',
    backgroundPosition: backgroundImage !== null && backgroundImage !== void 0 && (_backgroundImage$file4 = backgroundImage.file) !== null && _backgroundImage$file4 !== void 0 && _backgroundImage$file4.url && !(focalPointImage !== null && focalPointImage !== void 0 && focalPointImage.focalPoint) ? '50% 50%' : '',
    backgroundSize: backgroundImage !== null && backgroundImage !== void 0 && (_backgroundImage$file5 = backgroundImage.file) !== null && _backgroundImage$file5 !== void 0 && _backgroundImage$file5.url && !focalPointImage ? 'cover' : ''
  };
  var smallerDevice = isSmallDevice ? {
    justifiedContent: 'center',
    eyebrowFontSize: '14px',
    primaryBlock: MOBILE_BACKGROUND,
    primaryBlockPadding: '10px 0px 40px',
    textalign: 'center',
    headlineWidth: 9,
    bodyCopyWidth: 10,
    bodyCopyGridPadding: '',
    buttonWidth: 11,
    secondBlockPadding: '',
    secondaryMessageWidth: '292px',
    secondMessageFont: 'bodyLargeBook',
    seconLinkFont: 'lowestLevel',
    secondLinkFontSize: '18px',
    rowSpacing: 3
  } : {
    justifiedContent: 'flex-start',
    eyebrowFontSize: 'inherit',
    primaryBlock: ANGLE_BACKGROUND,
    primaryBlockPadding: isMediumDevice ? '10px 0px 30px 20px' : '0px 0px 0px 60px',
    textalign: 'left',
    headlineWidth: 7,
    bodyCopyWidth: 7,
    bodyCopyGridPadding: isMediumDevice ? '20px 0px 30px 0px' : '20px 0px 60px 0px',
    buttonWidth: isMediumDevice ? 7 : 5,
    secondBlockPadding: '0px 0px 8px 8px',
    secondaryMessageWidth: 'auto',
    secondMessageFont: 'bodyMediumBold',
    seconLinkFont: 'bodyMediumBold',
    rowSpacing: 0
  };
  var ctaDisplay = brandName !== 'wellnow' ? true : isSmallDevice;

  var childrenElements = function childrenElements() {
    var _backgroundImage$file6, _backgroundImage$file7, _tertiaryImage$file;

    return React.createElement(React.Fragment, null, isSmallDevice && (focalPointImage ? React.createElement(FocalPointImage, _objectSpread(_objectSpread({}, focalPointImage), {}, {
      backgroundImage: true,
      style: {
        minHeight: '248px',
        maxHeight: '512px'
      }
    })) : backgroundImage !== null && backgroundImage !== void 0 && (_backgroundImage$file6 = backgroundImage.file) !== null && _backgroundImage$file6 !== void 0 && _backgroundImage$file6.url ? React.createElement("img", {
      src: backgroundImage === null || backgroundImage === void 0 ? void 0 : (_backgroundImage$file7 = backgroundImage.file) === null || _backgroundImage$file7 === void 0 ? void 0 : _backgroundImage$file7.url,
      alt: "mobile image",
      width: "100%",
      style: {
        minHeight: '248px',
        maxHeight: '512px'
      }
    }) : React.createElement(Box, {
      sx: [{
        minHeight: '248px',
        maxHeight: '512px',
        backgroundColor: 'neutrals.disabled'
      }, sx]
    })), React.createElement(Grid, {
      item: true,
      container: true,
      direction: "column",
      sx: [smallerDevice.primaryBlock, {
        padding: smallerDevice.primaryBlockPadding
      }, sx],
      justifyContent: "center",
      rowSpacing: smallerDevice.rowSpacing
    }, React.createElement(Grid, {
      item: true,
      container: true,
      justifyContent: smallerDevice.justifiedContent
    }, React.createElement(Grid, {
      item: true
    }, eyebrow && React.createElement(TAGTypography, {
      fontStyle: "bodyMediumBook",
      color: allTextColor,
      sx: {
        fontSize: smallerDevice.eyebrowFontSize
      }
    }, eyebrow))), React.createElement(Grid, {
      item: true,
      container: true,
      justifyContent: smallerDevice.justifiedContent
    }, React.createElement(Grid, {
      xs: smallerDevice.headlineWidth,
      item: true,
      display: "flex",
      justifyContent: smallerDevice.justifiedContent,
      sx: {
        textAlign: smallerDevice.textalign
      }
    }, heading && React.createElement(TAGTypography, {
      variant: "h1",
      fontStyle: brandName === 'wellnow' ? 'heroMedium' : 'heroLarge',
      color: allTextColor,
      sx: headlineFontSwitch(bodySize, isSmallDevice, isMediumDevice, brandName)
    }, heading))), !isSmallDevice && (tertiaryImage === null || tertiaryImage === void 0 ? void 0 : (_tertiaryImage$file = tertiaryImage.file) === null || _tertiaryImage$file === void 0 ? void 0 : _tertiaryImage$file.url) && React.createElement(Grid, {
      item: true,
      container: true,
      sx: {
        margin: '0px 0px -15px -10px'
      }
    }, React.createElement(Grid, {
      item: true
    }, React.createElement("img", {
      src: tertiaryImage.file.url,
      alt: "tertiary image",
      width: "100%"
    }))), React.createElement(Grid, {
      item: true,
      container: true,
      justifyContent: smallerDevice.justifiedContent
    }, React.createElement(Grid, {
      xs: smallerDevice.bodyCopyWidth,
      item: true,
      sx: [{
        padding: smallerDevice.bodyCopyGridPadding
      }, sx],
      display: "flex",
      justifyContent: "center"
    }, body && React.createElement(TAGTypography, {
      variant: "bodyLargeBook",
      color: allTextColor,
      sx: bodyCopyFontSwitch(bodySize, isSmallDevice, isMediumDevice, brandName)
    }, body))), isSmallDevice && React.createElement(React.Fragment, null, secondImage && React.createElement(Grid, {
      item: true
    }, React.createElement("img", {
      src: secondImageURL,
      alt: "second mobile image",
      width: "100%",
      style: {
        minHeight: '248px',
        maxHeight: '512px',
        paddingBottom: '5px'
      }
    }))), ctaDisplay && React.createElement(Grid, {
      item: true,
      container: true,
      justifyContent: smallerDevice.justifiedContent,
      sx: [{
        paddingBottom: '10px'
      }, sx],
      spacing: 2
    }, React.createElement(Grid, {
      xs: 11,
      md: secondaryCtaText ? 4 : 5,
      item: true
    }, ctaStyle && ctaText && React.createElement(TAGButton, {
      buttonVariant: ctaStyle,
      href: ctaUrl,
      fullWidth: true,
      defaultButtonVariant: "Secondary High Contrast"
    }, ctaText)), secondaryCtaText && React.createElement(Grid, {
      xs: 11,
      md: 4,
      item: true
    }, React.createElement(TAGButton, {
      buttonVariant: secondaryCtaStyle,
      href: secondaryCtaUrl,
      fullWidth: true
    }, secondaryCtaText))), tc && isSmallDevice && React.createElement(Grid, {
      item: true,
      container: true,
      justifyContent: "center",
      sx: [sx]
    }, React.createElement(Grid, {
      item: true
    }, tc && React.createElement(TermsAndConditons, _objectSpread(_objectSpread({}, tc), {}, {
      branding: branding,
      isDark: true
    }))))));
  };

  return React.createElement(Container, {
    sx: _defineProperty({}, theme.breakpoints.down('md'), {
      paddingLeft: '0',
      paddingRight: '0'
    })
  }, focalPointImage ? React.createElement(FocalPointImage, _objectSpread(_objectSpread({}, focalPointImage), {}, {
    backgroundImage: true,
    style: {
      borderRadius: secondaryMessage ? '8px 8px 0px 0px' : '8px'
    }
  }), React.createElement(Grid, {
    container: true,
    direction: "column"
  }, childrenElements())) : React.createElement(Grid, {
    container: true,
    direction: "column",
    sx: [_objectSpread({
      borderRadius: secondaryMessage ? '8px 8px 0px 0px' : '8px'
    }, smallScreenImageStyles), sx]
  }, childrenElements()), secondaryMessage && React.createElement(Grid, {
    container: true,
    justifyContent: "center",
    sx: [{
      borderRadius: smallerDevice.secondBlockPadding,
      backgroundColor: secondaryBackground === 'dark' ? 'backgrounds.dark ' : 'backgrounds.light'
    }, sx]
  }, React.createElement(Grid, {
    item: true,
    sx: [{
      padding: '8px 0px'
    }, sx],
    display: "flex",
    justifyContent: "center"
  }, React.createElement(RichText, {
    branding: branding,
    backgroundColor: secondaryMessage.backgroundColor,
    contained: true,
    centerAlign: true,
    fullWidth: false,
    content: secondaryMessage.content
  }))), !isSmallDevice && React.createElement(Box, {
    sx: [{
      width: 'fit-content',
      position: 'relative',
      bottom: secondaryMessage ? '80px' : '40px',
      left: isMediumDevice ? '20px' : '60px'
    }, sx]
  }, tc && React.createElement(TermsAndConditons, _objectSpread(_objectSpread({}, tc), {}, {
    branding: branding,
    isDark: backgroundText
  }))));
};

export default Hero;